function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("title", null, "contacts-icon");

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  fill: "#fd5f54",
  width: 45.07,
  height: 39.92,
  rx: 3.97
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  fill: "#fff",
  x: 9.18,
  y: 10.31,
  width: 6.08,
  height: 2.46,
  rx: 0.55
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#fff",
  x: 9.18,
  y: 15.99,
  width: 6.08,
  height: 2.46,
  rx: 0.55
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#fff",
  x: 9.18,
  y: 21.78,
  width: 6.08,
  height: 2.46,
  rx: 0.55
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#fff",
  x: 9.18,
  y: 27.46,
  width: 6.08,
  height: 2.46,
  rx: 0.55
})), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M31.87,5.67H15.26a3.42,3.42,0,0,0-3.41,3.41v.8h3.32a.75.75,0,0,1,.75.74v1.81a.75.75,0,0,1-.75.74H11.85v2.41h3.32a.76.76,0,0,1,.75.75v1.8a.76.76,0,0,1-.75.75H11.85v2.41h3.32a.75.75,0,0,1,.75.74v1.81a.75.75,0,0,1-.75.74H11.85V27h3.32a.75.75,0,0,1,.75.74v1.81a.75.75,0,0,1-.75.74H11.85v.55a3.42,3.42,0,0,0,3.41,3.41H31.87a3.43,3.43,0,0,0,3.41-3.41V9.08A3.43,3.43,0,0,0,31.87,5.67ZM21.52,12.35l3.28,3.93-.74.64-3.39-4Zm9.59,14.28c-.71.88-2.23,1.46-4.49.26a22.78,22.78,0,0,1-6.79-5.84,9.46,9.46,0,0,1-1.71-3.86,3.26,3.26,0,0,1,.58-2.52c.18-.21.77-.8.77-.8l1-.77,3.4,4-1.21,1.13a1.62,1.62,0,0,0-.11,2.26,17.86,17.86,0,0,0,2.74,2.63c1.68,1.34,3.1-1.39,3.1-1.39l4.09,3.14S31.46,26.2,31.11,26.63Zm1.54-2-4.16-3.16.6-.86,4.15,3.24Z"
}));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45.07,
    height: 39.92,
    viewBox: "0 0 45.07 39.92"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/contacts-icon.cd796c40.svg";
export { SvgComponent as ReactComponent };